import React, {Component} from 'react';
import {Container} from 'semantic-ui-react'

import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom'

import './App.css';

import MainMenu from './MainMenu';
import CardList from './CardList'
import CardEdit from './CardEdit'
import PlaceList from './PlaceList'
import PlaceEdit from './PlaceEdit'

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {messages: []}; // <- set up react state
    }

    render() {
        return (
            <Router {...this.props}>
                <div>
                    <MainMenu/>
                    <Container style={{marginTop: 20}}>
                        <Route exact path="/cards" component={CardList}/>
                        <Route path="/cards/edit/:id?" component={CardEdit}/>
                        <Route exact path="/places" component={PlaceList}/>
                        <Route path="/places/edit/:id?" component={PlaceEdit}/>
                    </Container>
                </div>
            </Router>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js